import _axios from 'axios'
import store from '~store'
import * as Sentry from '@sentry/browser'

const CLIENT_API_URL = '/api'

const slowToastSpeedList = [{
  url: '/api/student/send-email',
  method: 'post'
}, {
  url: '/api/student/send-forget-email',
  method: 'post'
}, {
  url: '/api/enterprise/send-email',
  method: 'post'
}, {
  url: '/api/enterprise/send-forget-email',
  method: 'post'
}, {
  url: '/api/enterprise/school-hire-form',
  method: 'post'
}]

export class API {
  constructor(uri) {
    this._injectServerHeaderAuthorization = this._injectServerHeaderAuthorization.bind(this)
    this._injectServerErrorNotification = this._injectServerErrorNotification.bind(this)
    this._injectOtherErrorNotification = this._injectOtherErrorNotification.bind(this)
    this._commitBeforeRequestMutation = this._commitBeforeRequestMutation.bind(this)
    this._commitRequestErrorMutation = this._commitRequestErrorMutation.bind(this)
    this._commitAfterResponseMutation = this._commitAfterResponseMutation.bind(this)
    this._commitResponseErrorMutation = this._commitResponseErrorMutation.bind(this)

    const axios = _axios.create({
      baseURL: uri,
      responseType: 'json',
      timeout: 30000
    })

    axios.interceptors.request.use(this._commitBeforeRequestMutation, this._commitRequestErrorMutation)
    axios.interceptors.response.use(this._commitAfterResponseMutation, this._commitResponseErrorMutation)

    this.axios = axios
  }

  _injectServerHeaderAuthorization(config) {
    const token = store.getters['auth/tokenGetters']

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }

  _injectServerErrorNotification(error) {
    const {
      response
    } = error
    if (!response || !response.status) {
      return error
    }

    const {
      status
    } = response
    if (status >= 500 && status < 600) {
      store.dispatch('layouts/newToast', {
        variant: 'danger',
        message: `錯誤！！ HTTP ${status} `
        // speed: 'super-slow'
      })
    }

    return error
  }

  _injectOtherErrorNotification(error) {
    const {
      response
    } = error
    if (!response || !response.status) {
      return error
    }

    const {
      data,
      status
    } = response

    let errors = ''
    if (data.errors) {
      console.log(typeof data.errors)
      if (Array.isArray(data.errors)) { // Array
        errors = data.errors.join('</li><li>')
      } else if (data.errors.length) { // String
        errors = `${data.errors}</li><li>`
      } else { // Object
        Object.keys(data.errors).forEach(key => {
          errors += `${data.errors[key]}</li><li>`
        })
      }
    }
    if (data.error) {
      if (Array.isArray(data.error)) { // Array
        errors = data.error.join('</li><li>')
      } else if (data.error.length) { // String
        errors = `${data.error}</li><li>`
      } else { // Object
        Object.keys(data.error).forEach(key => {
          errors += `${data.error[key]}</li><li>`
        })
      }
    }
    if (data.message) {
      errors += `${data.message}`
    }

    store.dispatch('layouts/newToast', {
      variant: status >= 400 && status < 500 ? 'warning' : 'danger',
      title: status >= 400 && status < 500 ? '提醒你' : `錯誤！！ HTTP ${status} `,
      message: `<ul><li>${errors}</li></ul>`
      // speed: 'super-slow'
    })

    if ([
      'staging',
      'production'
    ].includes(process.env.MIX_SENTRY_ENV)) {
      Sentry.captureException(error)
      Sentry.captureMessage(data.message)
    }

    return error
  }

  _commitBeforeRequestMutation(config) {
    store.commit('layouts/setLoaderState', 'before-request')
    this._injectServerHeaderAuthorization(config)
    return config
  }

  _commitRequestErrorMutation(error) {
    store.commit('layouts/setLoaderState', 'request-error')

    store.dispatch('layouts/newToast', {
      variant: 'danger',
      title: '錯誤！',
      message: error.message
    })
    return Promise.reject(error)
  }

  _commitAfterResponseMutation(response) {
    store.commit('layouts/setLoaderState', 'after-response')
    const token = response.headers.authorization
    const expires = response.headers.tokenexpired
    const noNotification = response.config.headers['No-Success-Notification']

    if (token) {
      store.dispatch('auth/updateUserToken', { token, expires })
    }

    const {
      data: rspData,
      status,
      config
    } = response

    let message = ''
    let speed = 'quick'
    let data = rspData || {}
    let isBlob = data instanceof Blob
    if (Object.keys(data).includes('meta') && Object.keys(data.meta).includes('message')) {
      message = data.meta.message
    } else if (Object.keys(data).includes('message')) {
      if (Array.isArray(data.message)) {
        const messages = data.message.join('</li><li>')
        message = `<ul><li>${messages}</li></ul>`
      } else {
        message = data.message
      }
    } else if (!isBlob && Object.keys(data).includes('access_token')) {
      message = '登入成功'
    } else if (!isBlob && config.method !== 'get' && status >= 200 && status < 300) {
      message = '更新成功'
    }

    if (slowToastSpeedList.find(api => api.url === config.url && api.method === config.method)) {
      speed = 'slow'
    }
    if (message && !noNotification) {
      store.dispatch('layouts/newToast', {
        variant: 'success',
        message
        // speed
      })
    }
    return response
  }

  _commitResponseErrorMutation(error) {
    // this._injectServerErrorNotification(error)
    this._injectOtherErrorNotification(error)
    return Promise.reject(error)
  }
}

export default new API(CLIENT_API_URL).axios
